import { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";

function TermsOfSales() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        document.title = 'Vinimark | Terms of Sale'
        window.scrollTo(0,0);
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>

        <Header />
            <div
                style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    marginTop: isMobile ? '-30px' : '140px',
                    textAlign: "left",
                    minHeight: isMobile ? '70vh' : '650px',
                }}
            >
                <div style={{ flex: 1, height: '10px' }}></div>
                <div style={{ flex: 1, marginLeft: isMobile ? '24px' : '60px' }}>
                    <div style={{width: isMobile ? '90%': '70%'}}>
                        <p style={{ fontWeight: 600, textTransform: 'uppercase' }}>Terms & Conditions of Sale</p>
                        <p>All wines offered for sale are subject to availability.</p>
                        <p>All prices are quoted both exclusive and inclusive of VAT.</p>
                        <p>All prices are subject to change without prior notice.</p>
                        <p>All goods supplied and sold to the customer, remain the property of Vinimark Trading (Pty) Ltd. until full payment has been received.</p>
                        <p>Payment terms are COD or as otherwise agreed.</p>
                        <p>Interest will be charged on overdue accounts.</p>
                        <p>
                            A detailed list of the terms & conditions of sale are available upon request or can be downloaded at{' '}
                            <a style={{textDecoration: 'none', color: 'inherit'}} href="https://www.vinimark.co.za" target="_blank" rel="noopener noreferrer">
                                www.vinimark.co.za
                            </a>. All wines are sold in cases unless otherwise indicated.
                        </p>
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
}

export default TermsOfSales;

